import { useMemo, memo, lazy, Suspense, useEffect, useState } from "react";
import Header from "@/components/Header";
import PromoBanner from "@/components/PromoBanner";
import HomepageRenderer from "@/components/homepage/HomepageRenderer";
import LazySection from "@/components/LazySection";
import { useSearchParams } from "react-router-dom";
import JsonLdSchema from "@/components/JsonLdSchema";
import { getActiveHomepage } from "@/lib/builder/api";
import { BlocksRenderer } from "@/components/builder/BlockRenderer";
import type { BuilderPageRow } from "@/lib/builder/types";

const Footer = lazy(() => import("@/components/Footer"));

const Index = memo(() => {
  const [searchParams] = useSearchParams();
  const previewDesignId = useMemo(
    () => searchParams.get("preview_design") ? parseInt(searchParams.get("preview_design")!, 10) : null,
    [searchParams]
  );

  const [builderHome, setBuilderHome] = useState<BuilderPageRow | null | undefined>(undefined);
  useEffect(() => {
    let c = false;
    getActiveHomepage().then((p) => !c && setBuilderHome(p)).catch(() => !c && setBuilderHome(null));
    return () => { c = true; };
  }, []);

  return (
    <main className="min-h-screen bg-background scroll-smooth">
      <JsonLdSchema type="organization" />
      <PromoBanner />
      <Header />
      {builderHome ? (
        <div className="max-w-7xl mx-auto px-4 py-4"><BlocksRenderer blocks={builderHome.content || []} /></div>
      ) : (
        <HomepageRenderer previewDesignId={previewDesignId} />
      )}
      <LazySection height="320px" rootMargin="100px">
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </LazySection>
    </main>
  );
});

Index.displayName = "Index";

export default Index;
